import React, { useEffect, useState } from 'react';
import Cookie from 'js-cookie';
import style from './index.module.scss';
import { appHistory } from '@ice/stark-app';
import { config } from 'ice';

const apps = Object.keys(config.apps);

// 数据中心需要展示的店铺id
const showCustomDataShopIds = [7240988];

export default (props) => {
  const { pathname } = props;

  const [active, setActive] = useState('/web/crm/dashboard');
  const shopId = Cookie.get('shopId');

  const isShowCustomData = showCustomDataShopIds.includes(Number(shopId));
  const changeApp = (app) => {
    if (app === pathname) {
      return;
    }
    appHistory.push(app);
    setActive(app);
  };

  useEffect(() => {
    setActive(pathname);
  }, [pathname]);

  return (
    <div className={style.navs}>
      {
        Cookie.get('shopId') === '13057269' && <div
          className={`${style.navItem} ${
            active === '/web/crm/dashboard' ? style.navItemActive : ''
          }`}
          onClick={() => changeApp('/web/crm/dashboard')}
        >
          首页
        </div>
      }
      <div
        className={`${style.navItem} ${
          active !== '/web/crm/dashboard' && apps.every(app => !pathname.startsWith(app)) ? style.navItemActive : ''
        }`}
        onClick={() => changeApp('/web/cjyx')}
      >
        营销中心
      </div>
      <div
        className={`${style.navItem} ${
          (active.startsWith('/web/crm') && active !== '/web/crm/dashboard') ? style.navItemActive : ''
        }`}
        onClick={() => changeApp('/web/crm/member/list')}
      >
        会员中心
      </div>
      {
        isShowCustomData && (
          <div
            className={`${style.navItem} ${active.startsWith('/web/customdata') ? style.navItemActive : ''
              }`}
            onClick={() => changeApp('/web/customdata/yili/douYinMaternalDataboard')}
          >
            数据中心
          </div>
        )
      }
    </div>
  );
};
